import { TWEET } from '../constants/feedable_types'

export default {
  data() {
    return {
      shouldShowDeleteModal: false,
      deleteModal: null,
    }
  },

  methods: {
    /**
     * @param {Object} item - feed or comment object
     * @param {Boolean} isAdminInsights
     * @return {Boolean}
     */
    hasDeleteAuth({ item, isAdminInsights }) {
      if (item.feedable_type !== TWEET) {
        return false
      }

      if (isAdminInsights) {
        return true
      }

      if (item.author && item.author.current_user) {
        return true
      }

      return false
    },

    showDeleteModal(deleteModalSelector) {
      this.shouldShowDeleteModal = true
      this.$nextTick(() => {
        const $ = window.jQuery
        this.deleteModal = $(deleteModalSelector)

        this.deleteModal.on('hidden', () => {
          this.shouldShowDeleteModal = false
        })
        this.deleteModal.modal('show')
      })
    },

    executeDelete({ action, params }) {
      this.deleteModal.on('hidden', () => {
        this[action](params)
      })
    },
  },
}
